export default import.meta.ROLLDOWN_FILE_URL_X3Y9H7ji3HewbyaGyBtl_Q